/**
 * Shared helpers for the GPS coordinates returned by the API
 * (reservations, profiles, entities).
 */

/**
 * Tells whether a payload carries a usable pair of GPS coordinates.
 * @param {Object} payload - Any API object exposing latitude/longitude
 * @returns {boolean}
 */
export function hasCoordinates(payload) {
    return payload?.latitude != null && payload?.longitude != null;
}

/**
 * Formats a coordinates pair as "lat, lng" rounded to 5 decimals (~1 m).
 * @param {number} latitude - Latitude in WGS 84
 * @param {number} longitude - Longitude in WGS 84
 * @returns {string}
 */
export function formatCoordinates(latitude, longitude) {
    return `${Number(latitude).toFixed(5)}, ${Number(longitude).toFixed(5)}`;
}

/**
 * Builds a Google Maps search URL centered on the coordinates.
 * @param {number} latitude - Latitude in WGS 84
 * @param {number} longitude - Longitude in WGS 84
 * @returns {string}
 */
export function buildMapsUrl(latitude, longitude) {
    return `https://www.google.com/maps/search/?api=1&query=${latitude}%2C${longitude}`;
}
